import React from 'react'

import jasnaLogo from '@/assets/jasnaLogo.svg'

interface ChatCtaProps {
  onClick: () => void
  isHovered: boolean
  setIsHovered: (hovered: boolean) => void
}

const ChatCta: React.FC<ChatCtaProps> = ({ onClick, isHovered, setIsHovered }) => {
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-4 right-4 p-4 cursor-pointer transition-all duration-500 ease-in-out"
      style={{ zIndex: 1000 }}
    >
      <div
        className="bg-header-bg rounded-full flex items-center overflow-hidden transition-all duration-500"
        style={{
          width: isHovered ? '350px' : '73px',
          height: '73px',
          paddingRight: isHovered ? '1rem' : 0,
        }}
      >
        <div className="size-[73px] flex items-center justify-center shrink-0">
          <img className="w-[50px]" src={jasnaLogo} alt="Chat CTA" />
        </div>

        {isHovered && (
          <div className="ml-2 pr-2">
            <p
              className="text-white text-[12px] font-medium leading-snug"
              style={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                width: '260px',
                lineHeight: '1.3',
                maxHeight: '32px',
              }}
            >
              Здраво, ја сам Јасна ваш виртуелни асистент. Како могу да вам помогнем?
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ChatCta
